/**
 * drawer-menu.js
 */

import React from 'react';
import { useMediaQuery, List, ListItem, Divider } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 400,
    [theme.breakpoints.up('sm_md')]: {
      // maxHeight: props => props.isEditor ? 'calc(100% - 216px)' : '100%',
      marginRight: `calc(0px - ${theme.size.menuDrawer.menuPadding}px - ${theme.size.menuDrawer.arrowWidth}px - 2px)`,
      '& .MuiList-root': {
        paddingRight: theme.size.menuDrawer.arrowWidth + 2,
      },
      '& .scrollable-list .top, .scrollable-list .bottom': {
        marginRight: theme.size.menuDrawer.arrowWidth + 2,
      }
    },
  },
  menuRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: 0
    }
  },
  menuGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1),
    '&.can-scroll': {
      overflow: 'hidden',
    }
  },
  groupTitle: {
    padding: theme.spacing(1),
    fontSize: theme.typography.sizes[1],
    fontWeight: 'bold',
    color: theme.palette.sys.onSurfaceVariant,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm_md')]: {
      justifyContent: 'center',
    }
  },
  footerContainer: {
    position: 'relative',
    marginRight: theme.size.menuDrawer.menuPadding + theme.size.menuDrawer.arrowWidth + 2,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginTop: theme.spacing(2),
    },
    '& > svg': {
      display: 'block',
      width: '62%',
      maxWidth: 300,
      height: 'auto',
      margin: '0 auto',
      marginTop: theme.spacing(1),
      opacity: theme.palette.isDarkMode ? 0.3 : 0.2,
      '& .custom-fill': {
        fill: theme.palette.primary.colors[1],
      },
      '.billing-edit &': {
        filter: 'invert() hue-rotate(180deg)',
      },
    },
    '& .MuiButton-root': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)'
    },
  },
}));


export default function DrawerMenu(props) {
  const {
    menuGroups,
    header,
    footer,
    hideDivider,
  } = props;
  const classes = useStyles(props);
  const mobileLayout = useMediaQuery(theme => theme.breakpoints.down('sm_md'));


  return (
    <>
      {menuGroups &&
      <>
        <div className={classes.root} data-testtype="drawer-menu">

          {/* menu header */}
          {header}

          {/* menu */}
          <div className={classes.menuRoot}>
            {menuGroups.map((menuGroup, i) => {
              const ListComponent = menuGroup.component || List;
              return (
                <div
                  key={menuGroup.name || i}
                  className={`${classes.menuGroup} ${menuGroup.scrollable ? 'can-scroll' : ''}`}
                >

                  {/* section label (if exists) */}
                  {menuGroup.name &&
                  <ListItem className={classes.groupTitle}>
                    {menuGroup.name}
                  </ListItem>}

                  {/* items */}
                  <ListComponent>
                    {mobileLayout && !hideDivider && <Divider />}
                    {/* menu items */}
                    {menuGroup.items}
                  </ListComponent>

                </div>
              );
            })}
          </div>

          {/* menu footer */}
          {footer &&
          <div style={{ position: 'relative' }}>
            <div className={classes.footerContainer}>
              {footer}
            </div>
          </div>}

        </div>
      </>}
    </>
  );
}